import { observer } from 'mobx-react-lite';
import { Suspense, SyntheticEvent, useEffect, useState } from 'react';
import {
  Card,
  Header,
  Grid,
  Icon,
  Label,
  Segment,
  Form,
  Input,
  Button,
  Checkbox,
} from 'semantic-ui-react';
import { v4 as uuid } from 'uuid';
import { useStore } from '../../../app/stores/store';
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from 'react-beautiful-dnd';
import {
  cardcolor,
  errorEmptyText,
  errorMessageText,
  errortilde,
} from '../../../app/common/form/errorMessageText';
import {
  MetaDataET,
  MetaDataElement,
  MetaDataOptions,
} from './../../../app/models/metaDataConfig';
import MetaDataSettings from './MetaDataSettings';
import LoadingComponent from './../../../app/layout/LoadingComponent';
import DeleteModal from '../../../library/deleteModal';

const cardStyleLevel1 = {
  display: 'inline-block',
  padding: '10px',
  height: '77vh',
  width: '200pt',
  marginLeft: '-12px',
  marginTop: '40px',
  color: 'black',
  cursor: 'pointer',
  boxShadow: '5px 5px 10px lightgray',
};

function MetaDataComponent() {
  const {
    metaDataStore,
    workflowConfigurationStore,
    RolesAndPermissionsIDStore,
    userStore,
    modalStore,
    commonStore,
  } = useStore();
  const {
    selectedMetaDataET,
    createMetaDataTempUnderET,
    selectedMetaDataElem,
    loadMetaDataElemById,
    loadingInitialElem,
    selectedMetaDataAT,
    elementToggleOffEdit,
    editElements,
    editMetaDataET,
    deleteElements,
  } = metaDataStore;
  const [getreportskey, setgetreportskey] = useState<string | null>();
  const [newElements, setNewElements] = useState(
    workflowConfigurationStore.WorkflowConfiguration.metaDataConfigurationName,
  );
  const [subTaskElements, setSubTaskElements] = useState<
    MetaDataElement[] | undefined
  >(selectedMetaDataET?.metadata);
  const [errorType, setErrorType] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteOption, setDeleteOption] = useState<MetaDataElement>({
    elementValue: '',
    elementId: '',
    elementName: '',
    elementType: '',
    elementDateTime: '',
    creatorName: '',
    elementIndex: 0,
    isActive: false,
    isDeleted: false,
    options: [],
    enableByDefault: false,
    validation: '',
    files: [],
    photos: [],
    templateElementId: '',
    readOnly: false,
    parentMetadataID: [],
    metadatatype: '',
    parentId: '',
    isMandatory: false,
    span: '',
    hasChild: false,
    isMultiple: false,
    dynamicTypeName: '',
    dynamicTypeId: '',
    selectMasterComponent: '',
  });

  useEffect(() => {
    setSubTaskElements(selectedMetaDataET?.metadata);
  }, [selectedMetaDataET]);

  ///////// /////this function to handle when Enter Key is pressed
  const handleKeyPress = (e: any) => {
    if (
      e.key === 'Enter' &&
      workflowConfigurationStore.WorkflowConfiguration.editClickedElement ===
        false &&
      errorType !== 'tilde' &&
      errorType !== 'EmptyName' &&
      errorType !== 'SameName' &&
      !/\s/g.test(newElements?.charAt(0) || '')
    ) {
      hanldeAddElements();
    }
    if (
      e.key === 'Enter' &&
      workflowConfigurationStore.WorkflowConfiguration.editClickedElement ===
        true &&
      errorType !== 'tilde' &&
      errorType !== 'EmptyName' &&
      errorType !== 'SameName' &&
      !/\s/g.test(newElements?.charAt(0) || '')
    ) {
      handleSaveEdited('edit');
    }
  };

  const handleElement = (e: any, id: string) => {
    loadMetaDataElemById(id);
    workflowConfigurationStore.setShowElementName(id);
  };
  const hanldeAddElements = () => {
    if (errorType === 'SameName') {
      return;
    }
    if (
      selectedMetaDataET &&
      selectedMetaDataAT !== undefined &&
      newElements.length !== 0 &&
      errorType !== 'dot' &&
      errorType !== 'EmptyName' &&
      errorType !== 'SameName' &&
      !/\s/g.test(newElements?.charAt(0) || '')
    ) {
      const elements = selectedMetaDataET?.metadata;
      const IdForReference = uuid();
      const newArr: MetaDataElement = {
        elementId: IdForReference,
        elementName: newElements,
        elementDateTime: new Date().toISOString(),
        creatorName:
          userStore.user?.username !== undefined
            ? userStore.user?.username
            : 'bob',
        elementValue: '',
        elementType: 'TextBox',
        metadatatype: 'Metadata',
        elementIndex: elements.length,
        isActive: true,
        options: [],
        enableByDefault: false,
        isDeleted: false,
        validation: '',
        templateElementId: IdForReference,
        parentMetadataID: [''],
        parentId: '',
        readOnly: false,
        isMandatory: false,
        files: [],
        photos: [],
        selectMasterComponent: '',
      };
      const selectedSubTasksArr = {
        // for backend
        ...selectedMetaDataET,
        metadata: [newArr],
      };
      elements.push(newArr); // for front end schema
      const AllvaluefrontEndData = {
        // for front end schema
        ...selectedMetaDataET,
        elements: elements,
      };
      //For roles and permissions
      const newRoleArr = {
        id: uuid(),
        itemId: IdForReference,
        rolesId:
          userStore.user?.roleId !== undefined ? userStore.user?.roleId : '',
      };
      createMetaDataTempUnderET(selectedSubTasksArr, AllvaluefrontEndData);
      RolesAndPermissionsIDStore.createRoleID(newRoleArr); //roles and permissions
    } else {
      setErrorType('EmptyName');
    }
    setNewElements(''); // set value to empty
  };
  const toggleOnElements = (
    event: SyntheticEvent,
    data: any,
    element: MetaDataElement,
  ) => {
    elementToggleOffEdit(element.elementId);
  };
  //////////////////////// clone
  const handleClone = () => {
    if (errorType === 'SameName') {
      return;
    }
    if (
      selectedMetaDataET &&
      selectedMetaDataElem?.elementName &&
      newElements.length > 0 &&
      errorType !== 'dot' &&
      errorType !== 'EmptyName' &&
      errorType !== 'SameName' &&
      !/\s/g.test(newElements?.charAt(0) || '')
    ) {
      const Datas = selectedMetaDataET?.metadata;
      const NewIdGenerate = uuid();

      const mainClone = {
        ...selectedMetaDataElem,
        options: [...selectedMetaDataElem.options],
      };

      mainClone.elementId = NewIdGenerate;
      mainClone.elementIndex = Datas.length + 1;
      mainClone.elementName = newElements;
      //
      mainClone.options?.map((options: MetaDataOptions) => {
        return (options.optionId = uuid());
      });

      const MainArr = {
        ...selectedMetaDataET,
        metadata: [mainClone],
      };
      //  const frontEndArr
      Datas.push(mainClone);
      const AllvaluefrontEndData = {
        ...selectedMetaDataET,
        metadata: Datas,
      };
      createMetaDataTempUnderET(MainArr, AllvaluefrontEndData);
      setNewElements('');
    } else {
      setErrorType('EmptyName');
    }
  };
  ////////////////////////Drag and Drop
  const onDragEnd = (result: DropResult) => {
    loadMetaDataElemById(result.draggableId);
    if (subTaskElements) {
      const { source, destination } = result;
      if (!destination) return;
      let copySubTaskElements = [...subTaskElements];
      let elementId = copySubTaskElements[source.index].elementId;
      copySubTaskElements.splice(source.index, 1);
      copySubTaskElements.splice(
        destination.index,
        0,
        subTaskElements[source.index],
      );

      for (
        let i = destination.index;
        i < copySubTaskElements?.length || 0;
        i++
      ) {
        copySubTaskElements[i].elementIndex = i;
      }
      setSubTaskElements(copySubTaskElements);
      // subtask index
      let payload = {
        elementId,
        startIndex: source.index,
        endIndex: destination.index,
      };
      if (metaDataStore.selectedMetaDataET?.metadata)
        metaDataStore.selectedMetaDataET.metadata = copySubTaskElements;
      editMetaDataET(payload, copySubTaskElements);
    }
  };
  /////////////////////// edit clicked
  const handleEdit = (id: string, name: string) => {
    loadMetaDataElemById(id);
    setNewElements(name);
    workflowConfigurationStore.setEditClickedElement(true);
  };
  ///////////////////////// Save Edited
  const handleSaveEdited = (name: string) => {
    if (errorType === 'SameName' && name === 'edit') {
      return;
    }
    if (
      selectedMetaDataElem &&
      selectedMetaDataET !== undefined &&
      name === 'edit' &&
      newElements.length !== 0
    ) {
      const newArr = {
        ...selectedMetaDataElem,
        elementName: newElements,
      };
      editElements(newArr);
      //to update dom
      const data = selectedMetaDataET?.metadata;
      const index = data.findIndex(
        (obj) => obj.elementId === selectedMetaDataElem.elementId,
      );
      data[index].elementName = newElements;
    }
    setNewElements('');
    workflowConfigurationStore.setEditClickedElement(false);
  };
  ////////////////////////////handle Change
  const handleChangeName = (e: SyntheticEvent, data: any) => {
    setNewElements(data.value);
    const NameCheck = subTaskElements?.some(function (el) {
      return el.elementName === data.value;
    });
    setErrorType(NameCheck ? 'SameName' : ''); //check name exists
    if (data.value.includes('~')) {
      setErrorType('tilde');
    }
  };

  const handleWorkflowSettings = (id: string, elements: MetaDataElement) => {
    new Promise((resolve) => {
      loadMetaDataElemById(id);
      resolve('');
    }).then(() => {
      setTimeout(() => {
        modalStore.openModal(
          <MetaDataSettings
            elementsNames={(subTaskElements || [])?.flatMap((data) =>
              data.elementName !== elements.elementName
                ? {
                    key: data.templateElementId,
                    value: data.elementName,
                    text: data.elementName,
                  }
                : [],
            )}
          />,
        );
      }, 200);
    });
  };
  /////////////////////////////////
  const handleDeleteElement = (element: MetaDataElement) => {
    if (selectedMetaDataET !== undefined) {
      setDeleteOption(element);
      setIsModalOpen(true);
    }
  };
  const deleteConfirmed = () => {
    const elementDatas = selectedMetaDataET?.metadata;
    const elementArr = {
      ...deleteOption,
      isDeleted: true,
    };
    //  const frontEndArr to show Delete
    const filterData =
      elementDatas !== undefined
        ? elementDatas.filter(
            (item) => item.elementId !== deleteOption.elementId,
          )
        : [];
    const AllvaluefrontEndData = {
      ...selectedMetaDataET,
      metadata: filterData,
    };
    deleteElements(elementArr, AllvaluefrontEndData as MetaDataET);
    setIsModalOpen(false);
  };
  const MetaDataComponentJSX = (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided) => (
          <div
            className="templatepreset workflow-config-elements"
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {subTaskElements?.map((elements, index) => {
              return (
                <Draggable
                  key={elements.elementId}
                  draggableId={elements.elementId}
                  index={index}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <Card>
                        <Card.Content
                          onMouseEnter={() =>
                            setgetreportskey(elements.elementId)
                          }
                          onMouseLeave={() => setgetreportskey(null)}
                          style={
                            elements.elementId ===
                            workflowConfigurationStore.WorkflowConfiguration
                              .showElementName
                              ? cardcolor
                              : null
                          }
                          key={elements.elementId}
                        >
                          <Grid className="hoverColor" columns={3}>
                            <Grid.Row>
                              <Grid.Column
                                width={2}
                                style={{
                                  padding: '0',
                                }}
                              >
                                {getreportskey === elements.elementId ? (
                                  <div
                                    style={{
                                      display: 'flex',
                                    }}
                                    {...provided.dragHandleProps}
                                  >
                                    <Icon
                                      style={{
                                        cursor: 'all-Scroll',
                                        fontSize: '17px',
                                        marginTop: '2px',
                                      }}
                                      name="ellipsis vertical"
                                      color="grey"
                                      size="small"
                                    />
                                    <Icon
                                      style={{
                                        cursor: 'all-Scroll',
                                        fontSize: '17px',
                                        left: 7,
                                        position: 'absolute',
                                        marginTop: '2px',
                                      }}
                                      name="ellipsis vertical"
                                      color="grey"
                                      size="small"
                                    />
                                  </div>
                                ) : null}
                              </Grid.Column>
                              <Grid.Column
                                onClick={(e: any) =>
                                  handleElement(e, elements.elementId)
                                }
                                width={12}
                              >
                                {elements.elementName}
                              </Grid.Column>
                              <Grid.Column
                                width={2}
                                style={{
                                  padding: '0',
                                }}
                              >
                                <Checkbox
                                  key={index}
                                  style={{
                                    marginTop: '-3px',
                                    marginLeft: '-10px',
                                  }}
                                  onChange={(e: any, data: any) =>
                                    toggleOnElements(e, data, elements)
                                  }
                                  name={elements.elementName}
                                  className="table-toggle"
                                  toggle
                                  defaultChecked={
                                    elements.isActive ? true : false
                                  }
                                />
                              </Grid.Column>
                              {getreportskey === elements.elementId ? (
                                <Label
                                  attached="bottom right"
                                  style={{
                                    width: '92px',
                                    cursor: 'pointer',
                                  }}
                                  onMouseEnter={() =>
                                    workflowConfigurationStore.setDisableClick(
                                      true,
                                    )
                                  }
                                  onMouseLeave={() =>
                                    workflowConfigurationStore.setDisableClick(
                                      false,
                                    )
                                  }
                                >
                                  <Grid>
                                    <Grid.Row
                                      style={{
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <Grid.Column>
                                        {' '}
                                        <Icon
                                          name="pencil"
                                          color="grey"
                                          size="small"
                                          onClick={() =>
                                            handleEdit(
                                              elements.elementId,
                                              elements.elementName,
                                            )
                                          }
                                        />{' '}
                                      </Grid.Column>
                                      <Grid.Column>
                                        {' '}
                                        <Icon
                                          name="trash"
                                          color="grey"
                                          size="small"
                                          onClick={() =>
                                            handleDeleteElement(elements)
                                          }
                                        />{' '}
                                      </Grid.Column>
                                      <Grid.Column>
                                        <Icon
                                          onClick={() =>
                                            handleWorkflowSettings(
                                              elements.elementId,
                                              elements,
                                            )
                                          }
                                          // onClick={() => mediaAssetStore.settingsFormOpen( true ) }
                                          name="setting"
                                          color="grey"
                                          size="small"
                                        />
                                      </Grid.Column>
                                    </Grid.Row>
                                  </Grid>
                                </Label>
                              ) : null}
                            </Grid.Row>
                          </Grid>
                        </Card.Content>
                      </Card>
                    </div>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );

  return (
    <div>
      {isModalOpen && (
        <Suspense fallback={<></>}>
          <DeleteModal
            isModalOpen={isModalOpen}
            closeHandler={() => {
              setIsModalOpen(false);
            }}
            deleteHandler={deleteConfirmed}
            header={'Delete'}
            text={
              'Are you sure you want to delete this? Deleting it will also remove all related data.'
            }
          />
        </Suspense>
      )}
      <Card style={cardStyleLevel1}>
        <Header
          style={{ marginLeft: '20px', padding: '10px' }}
          size="huge"
          as="h1"
          content="Components"
          sub
          color="grey"
        />
        {!selectedMetaDataET || loadingInitialElem ? (
          <LoadingComponent />
        ) : (
          MetaDataComponentJSX
        )}

        <Segment className="workflow-bottom-card">
          <Form>
            <Form.Group widths="equal">
              <Form.Field
                id="form-input-control-error-email"
                className=" workflow-input"
                error={
                  errorType === 'SameName'
                    ? errorMessageText
                    : errorType === 'EmptyName'
                      ? errorEmptyText
                      : errorType === 'tilde'
                        ? errortilde
                        : null
                }
                control={Input}
                value={newElements}
                placeholder="Create New"
                onChange={handleChangeName}
                onKeyDown={handleKeyPress}
              />
            </Form.Group>
          </Form>
          {workflowConfigurationStore.WorkflowConfiguration
            .editClickedElement === false ? (
            <div className="workflow-input-div">
              {commonStore.filterModeTwo?.includes('SWMCB02') ? (
                <></>
              ) : (
                <Button
                  primary
                  onClick={handleClone}
                  disabled={
                    commonStore.filterModeZero?.includes('SWMCB02') ||
                    errorType === 'SameName' ||
                    errorType === 'EmptyName' ||
                    errorType === 'tilde'
                      ? true
                      : false
                  }
                  className="workflow-input-button"
                  error={
                    errorType === 'SameName'
                      ? errorMessageText
                      : errorType === 'EmptyName'
                        ? errorEmptyText
                        : null
                  }
                >
                  {' '}
                  Clone{' '}
                </Button>
              )}
              {/* <Button primary onClick={handleClone} disabled={!dashboardStore.dashboard.selectedUserRoleId.includes("SWMCB02")?true:false} className="workflow-input-button" error={errorType==='SameName'?errorMessageText:errorType==='EmptyName'?errorEmptyText:null}> Clone </Button> */}
              {commonStore.filterModeTwo?.includes('SWMCB01') ? (
                <></>
              ) : (
                <Button
                  color="green"
                  floated="right"
                  onClick={hanldeAddElements}
                  disabled={
                    commonStore.filterModeZero?.includes('SWMCB01') ||
                    errorType === 'SameName' ||
                    errorType === 'EmptyName' ||
                    errorType === 'tilde'
                      ? true
                      : false
                  }
                  className="workflow-input-button"
                  error={
                    errorType === 'SameName'
                      ? errorMessageText
                      : errorType === 'EmptyName'
                        ? errorEmptyText
                        : null
                  }
                >
                  Add New{' '}
                </Button>
              )}
              {/* <Button color="green" floated='right' onClick={hanldeAddElements} disabled={!dashboardStore.dashboard.selectedUserRoleId.includes("SWMCB01")?true:false}  className="workflow-input-button" error={errorType==='SameName'?errorMessageText:errorType==='EmptyName'?errorEmptyText:null}>Add New</Button> */}
            </div>
          ) : (
            <div className="workflow-input-div">
              <Button
                secondary
                onClick={() => handleSaveEdited('cancel')}
                className="workflow-input-button"
              >
                {' '}
                Cancel
              </Button>
              <Button
                primary
                floated="right"
                onClick={() => handleSaveEdited('edit')}
                className="workflow-input-button"
                error={
                  errorType === 'SameName'
                    ? errorMessageText
                    : errorType === 'EmptyName'
                      ? errorEmptyText
                      : null
                }
              >
                Save
              </Button>
            </div>
          )}
        </Segment>
      </Card>
    </div>
  );
}

export default observer(MetaDataComponent);
